import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Ponerle nombre",
    opening: localizedGenderNode(
      [
      "Hoy dejo de pensar “algo está mal en mí” y lo llamo por su nombre: sensación de fracaso."
    ],
      [
      "Hoy dejo de pensar “algo está mal en mí” y lo llamo por su nombre: sensación de fracaso."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Es una sensación. No es una sentencia.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Es una sensación. No es una sentencia.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿En qué áreas de mi vida vuelve esta sensación de fracaso?\n[Escribe aquí]",
      "2. ¿Qué historia me cuento sobre esto?\n[Escribe aquí]",
      "3. ¿Cómo se siente mi cuerpo cuando pienso “fracasé”?\n[Escribe aquí]"
    ],
      [
      "1. ¿En qué áreas de mi vida vuelve esta sensación de fracaso?\n[Escribe aquí]",
      "2. ¿Qué historia me cuento sobre esto?\n[Escribe aquí]",
      "3. ¿Cómo se siente mi cuerpo cuando pienso “fracasé”?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Sentir fracaso no es ser un fracaso."
    ],
      [
      "Cierre",
      "Sentir fracaso no es ser un fracaso."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: respiración + “Es una sensación, no una identidad.”",
      "Una vez hoy: respiración + “Es una sensación, no una identidad.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Hechos vs. Conclusiones",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que ocurrió de lo que digo que significa sobre mí."
    ],
      [
      "Hoy separo lo que ocurrió de lo que digo que significa sobre mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es el hecho puro? (sin interpretación)\n[Escribe aquí]",
      "2. ¿Qué conclusión dura apareció de inmediato?\n[Escribe aquí]",
      "3. ¿Qué interpretación más suave también es posible?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es el hecho puro? (sin interpretación)\n[Escribe aquí]",
      "2. ¿Qué conclusión dura apareció de inmediato?\n[Escribe aquí]",
      "3. ¿Qué interpretación más suave también es posible?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una conclusión no es un hecho."
    ],
      [
      "Cierre",
      "Una conclusión no es un hecho."
    ]
    ),
    action: localizedGenderNode(
      "“Hecho ≠ identidad.”",
      "“Hecho ≠ identidad.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "La voz que mide",
    opening: localizedGenderNode(
      [
      "Hoy reconozco la voz que mide éxito y fracaso."
    ],
      [
      "Hoy reconozco la voz que mide éxito y fracaso."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cómo me habla esa voz?\n[Escribe aquí]",
      "2. ¿Dónde aprendió a medir así?\n[Escribe aquí]",
      "3. ¿Qué tono diferente desearía?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cómo me habla esa voz?\n[Escribe aquí]",
      "2. ¿Dónde aprendió a medir así?\n[Escribe aquí]",
      "3. ¿Qué tono diferente desearía?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que creer a una voz que me empequeñece."
    ],
      [
      "Cierre",
      "No tengo que creer a una voz que me empequeñece."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece la medición: “Te escuché.”",
      "Cuando aparece la medición: “Te escuché.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Fracaso como evento, no identidad",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que pasó de quién soy."
    ],
      [
      "Hoy separo lo que pasó de quién soy."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué “fracaso” cargo desde hace años?\n[Escribe aquí]",
      "2. ¿Qué dice sobre mi intento — y no sobre mi valor?\n[Escribe aquí]",
      "3. ¿Qué aprendí realmente de eso?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué “fracaso” cargo desde hace años?\n[Escribe aquí]",
      "2. ¿Qué dice sobre mi intento — y no sobre mi valor?\n[Escribe aquí]",
      "3. ¿Qué aprendí realmente de eso?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Los eventos ocurren. Yo permanezco."
    ],
      [
      "Cierre",
      "Los eventos ocurren. Yo permanezco."
    ]
    ),
    action: localizedGenderNode(
      "Frase: “Pasó — y sigo aquí.”",
      "Frase: “Pasó — y sigo aquí.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Comparación que alimenta el fracaso",
    opening: localizedGenderNode(
      [
      "Hoy veo cómo la comparación fortalece la sensación de fracaso."
    ],
      [
      "Hoy veo cómo la comparación fortalece la sensación de fracaso."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Con quién me comparo?\n[Escribe aquí]",
      "2. ¿Qué no veo de su historia?\n[Escribe aquí]",
      "3. ¿Qué sí existe en mi vida — aunque sea silencioso?\n[Escribe aquí]"
    ],
      [
      "1. ¿Con quién me comparo?\n[Escribe aquí]",
      "2. ¿Qué no veo de su historia?\n[Escribe aquí]",
      "3. ¿Qué sí existe en mi vida — aunque sea silencioso?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La comparación borra el contexto."
    ],
      [
      "Cierre",
      "La comparación borra el contexto."
    ]
    ),
    action: localizedGenderNode(
      "Una detención de comparación hoy.",
      "Una detención de comparación hoy."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "El cuerpo y el fracaso",
    opening: localizedGenderNode(
      [
      "Hoy escucho a mi cuerpo, no solo a mis pensamientos."
    ],
      [
      "Hoy escucho a mi cuerpo, no solo a mis pensamientos."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiración lenta."
    ],
      [
      "Respiración lenta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde se siente el fracaso en mi cuerpo?\n[Escribe aquí]",
      "2. ¿Qué necesita mi cuerpo ahora?\n[Escribe aquí]",
      "3. ¿Qué alivio pequeño es posible?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde se siente el fracaso en mi cuerpo?\n[Escribe aquí]",
      "2. ¿Qué necesita mi cuerpo ahora?\n[Escribe aquí]",
      "3. ¿Qué alivio pequeño es posible?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El cuerpo pide escucha, no crítica."
    ],
      [
      "Cierre",
      "El cuerpo pide escucha, no crítica."
    ]
    ),
    action: localizedGenderNode(
      "Mano en pecho/vientre + respiración.",
      "Mano en pecho/vientre + respiración."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Éxitos pequeños que no conté",
    opening: localizedGenderNode(
      [
      "Hoy veo éxitos que no tuvieron titulares."
    ],
      [
      "Hoy veo éxitos que no tuvieron titulares."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Tres cosas que hice a pesar de la dificultad:\n[Escribe aquí]",
      "2. ¿Por qué tiendo a minimizarlas?\n[Escribe aquí]",
      "3. ¿Cómo se siente reconocerlas?\n[Escribe aquí]"
    ],
      [
      "1. Tres cosas que hice a pesar de la dificultad:\n[Escribe aquí]",
      "2. ¿Por qué tiendo a minimizarlas?\n[Escribe aquí]",
      "3. ¿Cómo se siente reconocerlas?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El progreso no siempre hace ruido."
    ],
      [
      "Cierre",
      "El progreso no siempre hace ruido."
    ]
    ),
    action: localizedGenderNode(
      "Escribir un éxito en mi cuaderno.",
      "Escribir un éxito en mi cuaderno."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Sostener el fracaso sin huir",
    opening: localizedGenderNode(
      [
      "Hoy permito que la sensación esté un minuto."
    ],
      [
      "Hoy permito que la sensación esté un minuto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué disparador activa el fracaso?\n[Escribe aquí]",
      "2. Práctica de un minuto: me quedo — sin arreglar.\n¿Qué pasó?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué disparador activa el fracaso?\n[Escribe aquí]",
      "2. Práctica de un minuto: me quedo — sin arreglar.\n¿Qué pasó?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La ola sube y baja."
    ],
      [
      "Cierre",
      "La ola sube y baja."
    ]
    ),
    action: localizedGenderNode(
      "Solo un minuto.",
      "Solo un minuto."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Responsabilidad sin castigo",
    opening: localizedGenderNode(
      [
      "Hoy asumo responsabilidad sin atacarme."
    ],
      [
      "Hoy asumo responsabilidad sin atacarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué sí es mi responsabilidad?\n[Escribe aquí]",
      "2. ¿Qué no lo es?\n[Escribe aquí]",
      "3. ¿Cómo se ve la responsabilidad con compasión?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué sí es mi responsabilidad?\n[Escribe aquí]",
      "2. ¿Qué no lo es?\n[Escribe aquí]",
      "3. ¿Cómo se ve la responsabilidad con compasión?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La responsabilidad construye, no destruye."
    ],
      [
      "Cierre",
      "La responsabilidad construye, no destruye."
    ]
    ),
    action: localizedGenderNode(
      "Una frase amable para mí.",
      "Una frase amable para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Fracaso y miedo",
    opening: localizedGenderNode(
      [
      "Hoy identifico el miedo bajo el fracaso."
    ],
      [
      "Hoy identifico el miedo bajo el fracaso."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿De qué tengo miedo que diga sobre mí?\n[Escribe aquí]",
      "2. ¿Cuál es la amenaza real?\n[Escribe aquí]",
      "3. ¿Qué verdad calmante existe?\n[Escribe aquí]"
    ],
      [
      "1. ¿De qué tengo miedo que diga sobre mí?\n[Escribe aquí]",
      "2. ¿Cuál es la amenaza real?\n[Escribe aquí]",
      "3. ¿Qué verdad calmante existe?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo habla fuerte."
    ],
      [
      "Cierre",
      "El miedo habla fuerte."
    ]
    ),
    action: localizedGenderNode(
      "Respiración + verdad calmante.",
      "Respiración + verdad calmante."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Valor personal no ligado al resultado",
    opening: localizedGenderNode(
      [
      "Hoy separo resultado de valor."
    ],
      [
      "Hoy separo resultado de valor."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde ato mi valor a los resultados?\n[Escribe aquí]",
      "2. ¿Qué cualidad mía existe sin importar el éxito?\n[Escribe aquí]",
      "3. ¿Cómo se siente separarlos?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde ato mi valor a los resultados?\n[Escribe aquí]",
      "2. ¿Qué cualidad mía existe sin importar el éxito?\n[Escribe aquí]",
      "3. ¿Cómo se siente separarlos?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Soy más que un resultado."
    ],
      [
      "Cierre",
      "Soy más que un resultado."
    ]
    ),
    action: localizedGenderNode(
      "Escribir una cualidad mía.",
      "Escribir una cualidad mía."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Cambiar el lenguaje interno",
    opening: localizedGenderNode(
      [
      "Hoy reemplazo una palabra."
    ],
      [
      "Hoy reemplazo una palabra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué palabra violenta me digo?\n[Escribe aquí]",
      "2. ¿Cómo suena en lenguaje humano?\n[Escribe aquí]",
      "3. ¿Qué palabra nueva elijo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué palabra violenta me digo?\n[Escribe aquí]",
      "2. ¿Cómo suena en lenguaje humano?\n[Escribe aquí]",
      "3. ¿Qué palabra nueva elijo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Las palabras crean realidad."
    ],
      [
      "Cierre",
      "Las palabras crean realidad."
    ]
    ),
    action: localizedGenderNode(
      "Un reemplazo solamente.",
      "Un reemplazo solamente."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Dirección en lugar de prueba",
    opening: localizedGenderNode(
      [
      "Hoy elijo dirección, no prueba."
    ],
      [
      "Hoy elijo dirección, no prueba."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué valor es importante para mí ahora?\n[Escribe aquí]",
      "2. ¿Qué acción pequeña lo sirve?\n[Escribe aquí]",
      "3. ¿Qué me prometo en días difíciles?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué valor es importante para mí ahora?\n[Escribe aquí]",
      "2. ¿Qué acción pequeña lo sirve?\n[Escribe aquí]",
      "3. ¿Qué me prometo en días difíciles?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La dirección es suficiente."
    ],
      [
      "Cierre",
      "La dirección es suficiente."
    ]
    ),
    action: localizedGenderNode(
      "Planear un paso pequeño.",
      "Planear un paso pequeño."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro un capítulo sin borrarme."
    ],
      [
      "Hoy cierro un capítulo sin borrarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué cambió en mi relación con el fracaso?\n[Escribe aquí]",
      "2. ¿Qué sé ahora que antes no sabía?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué cambió en mi relación con el fracaso?\n[Escribe aquí]",
      "2. ¿Qué sé ahora que antes no sabía?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final",
      "No soy la suma de mis fracasos.",
      "Soy una persona en proceso.",
      "Y permanezco conmigo.",
      "Eso es fortaleza."
    ],
      [
      "Cierre final",
      "No soy la suma de mis fracasos.",
      "Soy una persona en proceso.",
      "Y permanezco conmigo.",
      "Eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice continuidad.",
      "Una acción que simbolice continuidad."
    ),
  },
].map(buildNormalizedDay);

export const chronicSenseOfFailureBlueprintEs = buildNormalizedPilotBlueprint({
  id: "chronic_sense_of_failure_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "chronic_sense_of_failure",
  category: "general",
  journeyName: {
    he: "תחושת כישלון כרונית",
    en: "Chronic Sense of Failure",
    es: "Sensación Crónica de Fracaso",
  },
  days,
});

export default chronicSenseOfFailureBlueprintEs;
